import { Datatype } from '../../../../../expressions/datatype/Datatype.ts';
import { AdvancedSelectRichTextValue } from '../utils/AdvancedSelectRichTextValue.tsx';
import { formatValueByDatatype } from '../utils/formatValueByDatatype.ts';

/**
 * Restituisce una funzione di rendering basata sul tipo di dato.
 */
export function getAdvancedSelectColumnRenderByDatatype(
  type: Datatype | undefined,
) {
  return (value: any) => {
    if (value == null || value === '') return <span>-</span>;
    if (type === Datatype.RichText) {
      return <AdvancedSelectRichTextValue value={value} />;
    }
    if (type == null) return <span>{String(value)}</span>;
    return <span>{formatValueByDatatype(value, type)}</span>;
  };
}
